// extracted by mini-css-extract-plugin
export var aboveInput = "_mr-0";
export var actionButton = "_mr-5";
export var actionButtonContainer = "_mr-1";
export var actionIcon = "_mr-6";
export var aiInfoContainer = "_mr-2";
export var attachmentWrapper = "_mr-7";
export var bold = "_mr-3";
export var checkIcon = "_mr-8";
export var clickingRecipientBar = "_mr-11";
export var commentThreadSwitch = "_mr-a";
export var draftImage = "_mr-b";
export var draftImageContainer = "_mr-c";
export var draftImages = "_mr-e";
export var editButton = "_mr-g";
export var editor = "_mr-f";
export var editorContainer = "_mr-y";
export var editorErrorTooltipWrapper = "_mr-9";
export var headerDivider = "_mr-h";
export var icon = "_mr-i";
export var info = "_mr-j";
export var internal = "_mr-n";
export var internalDivider = "_mr-k";
export var internalMessage = "_mr-l";
export var messageInputCard = "_mr-m";
export var messageInputForm = "_mr-o";
export var messageInputFormInternal = "_mr-p";
export var options = "_mr-q";
export var publicMessageCustomer = "_mr-s";
export var publicMessageMerchant = "_mr-r";
export var removeImageButton = "_mr-d";
export var replyButtons = "_mr-t";
export var showSignatureButton = "_mr-u";
export var spinner = "_mr-v";
export var verticalButtonDivider = "_mr-4";
export var visibilitySelector = "_mr-w";
export var warning = "_mr-x";
export var wrappingText = "_mr-z";
export var writingInternalNoteTopBorder = "_mr-10";